/* 🔒 Decision 5570: the one booking form's own constructions — the inline form on the Visits tile, and Who Can Go inside a form. */
.inline {
  display: grid;
  gap: var(--space-3);
  padding: var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-small);
}

.heading {
  margin: 0;
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-semibold);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.whoCanGo {
  display: grid;
  gap: var(--space-2);
}

.candidates {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: var(--space-1);
}

.candidate {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-1) var(--space-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-small);
}

.candidateName {
  font-weight: var(--font-weight-semibold);
}

.muted {
  color: var(--text-muted);
  font-size: var(--font-size-small);
}

.busy {
  color: var(--status-warning-text);
  font-size: var(--font-size-small);
}

.problem {
  color: var(--status-error-text);
  font-size: var(--font-size-small);
}

/* 🔒 Decision 5571: the lines a visit covers, and each worker's lines beneath. */
.lines {
  display: grid;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  border: 0;
}

.lineChoices {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2) var(--space-4);
}

.workerLines {
  display: grid;
  gap: var(--space-1);
}
